export default __webpack_public_path__ + "static/media/Interior (14).2e147c0e.jpg";